import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function BannerMediumSlider() {
  var swiper;

  function initializeSwiper() {
    var w = window.innerWidth;
    var sliderClass = w < 768 ? ".js-banner-slider-medium-sp" : ".js-banner-slider-medium-pc";
    var paginationClass = w < 768 ? ".js-banner-slider-medium-pagination-sp" : ".js-banner-slider-medium-pagination-pc";

    swiper = new Swiper(sliderClass, {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: true,
      spaceBetween: 20,
      speed: 300,
      breakpoints: {
        768: {
          slidesPerView: "auto",
          centeredSlides: true,
        },
      },
      pagination: {
        el: paginationClass,
        clickable: true, // クリック可能にする
      },
      navigation: {
        nextEl: ".js-banner-slider-medium-next",
        prevEl: ".js-banner-slider-medium-prev",
      },
      keyboard: {
        enabled: true,
      },
    });
  }

  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  function handleResize() {
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var sliderClass = w < 768 ? ".js-banner-slider-medium-sp" : ".js-banner-slider-medium-pc";
    var slideCount = $(sliderClass).find(".swiper-slide").length;

    if (slideCount === 1) {
      destroySwiper();
      $(".js-banner-slider-medium-control").hide();
    } else if (w >= 768) {
      if (slideCount === 2) {
        destroySwiper();
        $(".js-banner-slider-medium-control").hide();
      } else {
        initializeSwiper();
        $(".js-banner-slider-medium-control").show();
      }
    } else {
      initializeSwiper();
      $(".js-banner-slider-medium-control").show();
    }
  }
  // 初回実行
  handleResize();
  window.addEventListener("resize", handleResize);

  //再生/停止ボタン
  $(".js-banner-slider-medium-stop-button").on("click", function () {
    if ($(this).hasClass("is-pause")) {
      swiper.autoplay.start();
      $(this).removeClass("is-pause");
      $(this).text("停止する");
    } else {
      swiper.autoplay.stop();
      $(this).addClass("is-pause");
      $(this).text("再生する");
    }
  });
}

export { BannerMediumSlider };
